import { Component, OnInit } from '@angular/core';
import { PaycardSubject } from '../../../model';
import { TableReactiveUrlController } from '@amlCore/tableReactive';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@amlCore/utils';
import { RegistriesService } from '../../../service';
import { TableService, UserService, VisitedService } from '@amlCore/services';
import { AccessJson, FilterParams } from '@amlCore/models';
import {RegistriesAccessEnum} from "@amlCore/enums";

@Component({
  selector: "app-paycard-info-list",
  templateUrl: "./paycardInfoList.component.html",
})
// TODO переименовать компонент в PaycardSubjectListComponent
export class PaycardInfoListComponent
  extends TableReactiveUrlController
  implements OnInit
{
  isShowVisited = true;
  constructor(
    protected regSrv: RegistriesService,
    protected route: ActivatedRoute,
    protected visitedService: VisitedService,
    protected tableService: TableService,
    protected readonly userSrv: UserService,
    protected router: Router
  ) {
    super(router, route, visitedService, tableService, {
      pageSize: 20,
      sort: "kokcm",
      dir: "ASC",
    });
  }

  paycardSubjects: PaycardSubject[];
  access: AccessJson;

  ngOnInit(): void {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.CLS_CTFB);

    this.activatedRoute.queryParams.subscribe((data) => {
      this.loadList(this.syncParams(data));
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  onPageChange(params): void {
    const filter = this.getParams({ ...params, ...this.filter });
    this.navigate(filter);
  }

  loadList(params?: any): void {
    Utils.removeKeysFromObj(params, '$refresh');
    this.regSrv.getPaycardSubjectList(this.getParams(params) as FilterParams).subscribe((data) => {
      this.paycardSubjects = data.content;
      this.total = data.totalElements ?? data.totalSize;
    });
  }

  /**
   * Метод вызываемый после импорта
   */
  importLoad(): void {
    // Подмешиваем случайную переменную для реализации обновления при импорте
    this.onPageChange({ $refresh: Math.random() });
  }
}
